//获取当天日期
export function getNowDate() {
    var myDate = new Date();
    var year = myDate.getFullYear();
    var month = (myDate.getMonth() + 1);
    if (month < 10) {
        month = "0" + month;
    }
    var day = myDate.getDate();
    if (day < 10) {
        day = "0" + day;
    }
    return year + '-' + month + '-' + day;
}

/**
 * 获取某周的开始时间和结束时间
 * @param {*} type "s"代表开始,"e"代表结束
 * @param {*} dates 不传或0代表本周，-1代表上周，1代表下周
 * @returns 
 */
export function getWeek(type, dates) {
    var now = new Date();
    var nowTime = now.getTime();
    var day = now.getDay();
    var longTime = 24 * 60 * 60 * 1000;
    var n = longTime * 7 * (dates || 0);
    var dd;
    if (type == "s") {
        dd = nowTime - (day - 1) * longTime + n;
    }
    if (type == "e") {
        dd = nowTime + (7 - day) * longTime + n;
    }
    dd = new Date(dd);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1;
    var d = dd.getDate();
    m = m < 10 ? "0" + m : m;
    d = d < 10 ? "0" + d : d;
    return y + "-" + m + "-" + d;
}

/**
 * 获取某月的开始时间和结束时间
 * @param {*} type "s"代表开始,"e"代表结束
 * @param {*} months 不传或0代表本月，-1代表上月，1代表下月
 * @returns 
 */
export function getMonth(type, months) {
    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    if (Math.abs(months) > 12) {
        months = months % 12;
    }
    if (months != 0) {
        if (month + months > 12) {
            year++;
            month = (month + months) % 12;
        } else if (month + months < 1) {
            year--;
            month = 12 + month + months;
        } else {
            month = month + months;
        }
    }
    month = month < 10 ? "0" + month : month;
    var firstday = year + "-" + month + "-" + "01";
    var lastday = "";
    if (month == "01" || month == "03" || month == "05" || month == "07" || month == "08" || month == "10" || month == "12") {
        lastday = year + "-" + month + "-" + 31;
    } else if (month == "02") {
        if ((year % 4 == 0 && year % 100 != 0) || (year % 100 == 0 && year % 400 == 0)) {
            lastday = year + "-" + month + "-" + 29;
        } else {
            lastday = year + "-" + month + "-" + 28;
        }
    } else {
        lastday = year + "-" + month + "-" + 30;
    }
    var day = "";
    if (type == "s") {
        day = firstday;
    } else {
        day = lastday;
    }
    return day;
}